import { useEffect } from 'react'
import { absoluteOgImage, absoluteUrl, siteName } from '../config/site'
import { toMetaDescription } from '../seo/usePageSeo'

export function JsonLd({ data }) {
  const json = JSON.stringify(data)

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-wyrd-jsonld', 'true')
    script.textContent = json
    document.head.appendChild(script)
    return () => {
      script.remove()
    }
  }, [json])

  return null
}

export function HomeJsonLd({ description }) {
  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            name: siteName,
            url: absoluteUrl('/'),
            logo: absoluteUrl('/logo.svg'),
          },
          {
            '@type': 'WebSite',
            name: siteName,
            url: absoluteUrl('/'),
            description,
          },
        ],
      }}
    />
  )
}

/** Schema.org Product per pagine miniature / file stampabili. */
export function ProductJsonLd({
  name,
  description,
  path,
  images,
  price,
  sold = false,
}) {
  const url = absoluteUrl(path)
  const plainDescription = toMetaDescription(description, 5000)
  const imageUrls = (images ?? [])
    .filter(Boolean)
    .map((src) => absoluteOgImage(src))
  const priceNum = Number(price)

  const data = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    url,
    brand: { '@type': 'Brand', name: siteName },
    ...(plainDescription ? { description: plainDescription } : {}),
    ...(imageUrls.length > 0 ? { image: imageUrls } : {}),
    ...(Number.isFinite(priceNum)
      ? {
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'EUR',
            price: priceNum,
            availability: sold
              ? 'https://schema.org/OutOfStock'
              : 'https://schema.org/InStock',
          },
        }
      : {}),
  }

  return <JsonLd data={data} />
}
